import { useGSAP } from "@gsap/react";
import React, { useRef } from "react";
import { animateScrollTrigger } from "../utils/Animation";
import { explore1Img, explore2Img, exploreVideo } from "../utils";
import gsap from "gsap";

const Features = () => {
  const videoRef = useRef();
  useGSAP(() => {
    gsap.to("#explore", {
      scrollTrigger: {
        trigger: "#explore",
        toggleActions: "play pause reverse restart",
        start: "-10% bottom",
      },
      onComplete:()=>{
      videoRef.current.play();
    }
    });
    animateScrollTrigger("#features_title,.title2", {
      y: 0,
      opacity: 1,
      duration: 1.5,
    });
    animateScrollTrigger(
      ".g_grow",
      { scale: 1, opacity: 1, ease: "power1" },
      { scrub: 5.5 }
    );
    animateScrollTrigger(".g_text", {
      opacity: 1,
      y: 0,
      duration: 1,
      ease: "power1.inOut",
    });
  }, []);
  return (
    <section className="sm:py-32 py-20 sm:px-10 px-5 h-full relative overflow-hidden bg-zinc-950">
      <div className="screen-max-width">
        <div className="mb-12 w-full">
          <h1
            id="features_title"
            className="text-gray lg:text-6xl md:text-5xl text-3xl lg:mb-0 mb-5 font-medium opacity-0 translate-y-20"
          >
            Explore The Full Story
          </h1>
        </div>
        <div className="flex flex-col justify-center items-center overflow-hidden">
          <div className="mt-12 mb-24 opacity-0 translate-y-20 pl-24 title2">
            <h2 className="text-5xl lg:text-7xl font-semibold">iPhone.</h2>
            <h2 className="text-5xl lg:text-7xl font-semibold">
              Forged in titanium.
            </h2>
          </div>

          <div className="flex justify-center items-center flex-col sm:px-10">
            <div className="relative h-[50vh] w-full flex items-center">
              <video
                playsInline
                id="explore"
                className="w-full h-full object-cover object-center"
                preload="none"
                muted
                autoPlay
                ref={videoRef}
              >
                <source src={exploreVideo} type="video/mp4" />
              </video>
            </div>
            <div className="flex flex-col w-full relative">
              <div className="w-full flex flex-col md:flex-row gap-5 items-center">
                <div className="overflow-hidden flex-1 h-[50vh]">
                  <img
                    src={explore1Img}
                    alt="titanium"
                    className="w-full h-full object-cover object-center scale-150 opacity-0 g_grow"
                  />
                </div>
                <div className="overflow-hidden flex-1 h-[50vh]">
                  <img
                    src={explore2Img}
                    alt="titanium"
                    className="w-full h-full object-cover object-center scale-150 opacity-0 g_grow"
                  />
                </div>
              </div>
              <div className="w-full justify-center items-center flex flex-col md:flex-row mt-10 md:mt-16 gap-5">
                <div className="flex flex-1 justify-center items-center ">
                  <p className="text-gray-600 max-w-md text-lg md:text-xl font-semibold translate-y-[100px] opacity-0 g_text">
                    iPhone 15 Pro is{" "}
                    <span className="text-white">
                      the first iPhone to feature an aerospace-grade titanium
                      design{" "}
                    </span>
                    using the same alloy that spacecrafts use for missions to
                    Mars.
                  </p>
                </div>
                <div className="flex flex-1 justify-center items-center">
                  <p className="text-gray-600 max-w-md text-lg md:text-xl font-semibold translate-y-[100px] opacity-0 g_text">
                    Titanium has one of the best strength-to-weight ratios of
                    any metal,making these our{" "}
                    <span className="text-white">
                      lightest Pro models ever{" "}
                    </span>
                    You'll notice the difference the moment you pick one up.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
